module.exports = __webpack_public_path__ + "img/Nos stations.06f8a325.jpg";